import 'element-plus/dist/index.css'
import {

    // 导航菜单相关组件
    ElMenu,
    ElSubMenu,
    ElMenuItem,
    ElMenuItemGroup,
    ElPageHeader,
    ElDropdown,

    // 基础：布局容器相关组件
    ElContainer,
    ElHeader,
    ElMain,
    ElFooter,
    ElAside,
    ElRow,
    ElCol,

    //基础
    ElLink,
    ElButton,
    ElIcon,


    // 表格相关组件
    ElTable, // table
    ElTableColumn,
    ElPagination,

    // 表单
    ElForm, // form
    ElFormItem,
    ElInput,
    ElSelect,
    ElInputNumber,

    // 提示
    ElMessage,
    ElDialog,
    ElDivider,








    // Breadcrumb,
    // BreadcrumbItem,




    // InputNumber,
    // Radio,
    // RadioGroup,
    // RadioButton,
    // Checkbox,
    // CheckboxButton,
    // CheckboxGroup,
    // Switch,

    // Option,
    // OptionGroup,
    // Button,
    // ButtonGroup,

    // DatePicker, // 时间
    // TimeSelect,
    // TimePicker,
    // Row,
    // Col,


    // Loading,
    // MessageBox,

    // Notification,

    // image,


} from 'element-plus'


export default function(app) {

    app.config.globalProperties.$ELEMENT = { size: 'small', zIndex: 3000 }

    // 导航相关组件
    app.use(ElMenu);
    app.use(ElSubMenu);
    app.use(ElMenuItem);
    app.use(ElMenuItemGroup);
    app.use(ElPageHeader);
    app.use(ElDropdown);

    // 基础：布局容器相关组件
    app.use(ElContainer);
    app.use(ElAside);
    app.use(ElMain);
    app.use(ElFooter);
    app.use(ElHeader);
    app.use(ElRow);
    app.use(ElCol);

    // 基础
    app.use(ElLink)
    app.use(ElButton);
    app.use(ElIcon);

    // 数据相关组件
    app.use(ElTable);
    app.use(ElTableColumn);
    app.use(ElPagination);

    // 表单
    app.use(ElForm);
    app.use(ElFormItem);
    app.use(ElInput);
    app.use(ElSelect);
    app.use(ElInputNumber);


    // 提示
    app.use(ElMessage)
    app.use(ElDialog)
    app.use(ElDivider)





    // app.use(Breadcrumb);
    // app.use(BreadcrumbItem);



    // app.use(InputNumber);
    // app.use(Radio);
    // app.use(RadioGroup);
    // app.use(RadioButton);
    // app.use(Checkbox);
    // app.use(CheckboxButton);
    // app.use(CheckboxGroup);
    // app.use(Switch);
    // app.use(Option);
    // app.use(OptionGroup);
    // app.use(Button);
    // app.use(ButtonGroup);
    // app.use(DatePicker);
    // app.use(TimeSelect);
    // app.use(TimePicker);
    // app.use(Row);
    // app.use(Col);
    // app.use(image);
    // app.use(Loading.directive);

    // app.prototype.$loading = Loading.service;
    // app.prototype.$msgbox = MessageBox;
    // app.prototype.$alert = MessageBox.alert;
    // app.prototype.$confirm = MessageBox.confirm;
    // app.prototype.$prompt = MessageBox.prompt;
    // app.prototype.$notify = Notification;
    app.config.globalProperties.$message = ElMessage;
}